import * as Scrivito from "scrivito";

const LoginRedirect = Scrivito.provideObjClass("LoginRedirectPage", {
  attributes: {
    title: "string",
    intranetStudentLink: "reference",
    intranetEmployeeLink: "reference",
    loginButtonText: "string",
    content: [
      "widgetlist",
      {
        only: [
          "SectionContentWidget",
          "HeroSliderWidget",
          "InpageNavigationWidget",
        ],
      },
    ],
  },
});

export default LoginRedirect;
